import { c as _c } from "react/compiler-runtime";
import { FAQ } from "./types";
interface CollapsibleItemProps {
  faq: FAQ;
  isOpen: boolean;
  onToggle: () => void;
}
export function CollapsibleItem(t0) {
  const $ = _c(19);
  const {
    faq,
    isOpen,
    onToggle
  } = t0;
  let t1;
  if ($[0] !== faq.question) {
    t1 = <h3 className="text-lg font-semibold text-gray-800">{faq.question}</h3>;
    $[0] = faq.question;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `text-gray-500 transition-transform ${isOpen ? "rotate-180" : ""}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <span className={t2}>{t3}</span>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t4) {
    t5 = <div className="flex justify-between items-center">{t1}{t4}</div>;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onToggle || $[9] !== t5) {
    t6 = <button onClick={onToggle} className="w-full text-left p-6 hover:bg-gray-50 transition-colors focus-modern">{t5}</button>;
    $[8] = onToggle;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`;
  let t8;
  if ($[11] !== faq.answer) {
    t8 = <div className="px-6 pb-6"><p className="text-gray-600 leading-relaxed">{faq.answer}</p></div>;
    $[11] = faq.answer;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <div className="bg-white border border-gray-200 rounded-lg shadow-sm">{t6}{t9}</div>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}